// extracted by mini-css-extract-plugin
module.exports = {"brandList":"_3l97J0_SMEDK-QZjsAUlc_","brandListItem":"_1fMa1b7lkcpe2apxI16R2j"};